import _ from 'lodash';
import { countries as list } from 'country-data';

export const renderCountryName = code => {
  const country = _.find(list.all, ['alpha2', code]);
  return _.get(country, 'name', '-');
};

const countries = [
  {
    text: 'United Kingdom',
    value: 'GB',
    key: 'GB',
    flag: 'gb',
  },
  {
    text: 'United Kingdom',
    value: 'UK',
    key: 'UK',
    flag: 'gb',
  },
  {
    text: 'United States',
    value: 'US',
    key: 'US',
    flag: 'us',
  },
  {
    text: 'Ireland',
    value: 'IE',
    key: 'IE',
    flag: 'ie',
  },
  {
    text: 'Global',
    value: 'ZZ',
    key: 'ZZ',
    image: { src: '/icons/global-icon.png' },
  },
  {
    text: 'Afghanistan',
    value: 'AF',
    key: 'AF',
    flag: 'af',
  },
  {
    text: 'Åland Islands',
    value: 'AX',
    key: 'AX',
    flag: 'ax',
  },
  {
    text: 'Albania',
    value: 'AL',
    key: 'AL',
    flag: 'al',
  },
  {
    text: 'Algeria',
    value: 'DZ',
    key: 'DZ',
    flag: 'dz',
  },
  {
    text: 'American Samoa',
    value: 'AS',
    key: 'AS',
    flag: 'as',
  },
  {
    text: 'AndorrA',
    value: 'AD',
    key: 'AD',
    flag: 'ad',
  },
  {
    text: 'Angola',
    value: 'AO',
    key: 'AO',
    flag: 'ao',
  },
  {
    text: 'Anguilla',
    value: 'AI',
    key: 'AI',
    flag: 'ai',
  },
  {
    text: 'Antigua and Barbuda',
    value: 'AG',
    key: 'AG',
    flag: 'ag',
  },
  {
    text: 'Argentina',
    value: 'AR',
    key: 'AR',
    flag: 'ar',
  },
  {
    text: 'Armenia',
    value: 'AM',
    key: 'AM',
    flag: 'am',
  },
  {
    text: 'Aruba',
    value: 'AW',
    key: 'AW',
    flag: 'aw',
  },
  {
    text: 'Australia',
    value: 'AU',
    key: 'AU',
    flag: 'au',
  },
  {
    text: 'Austria',
    value: 'AT',
    key: 'AT',
    flag: 'at',
  },
  {
    text: 'Azerbaijan',
    value: 'AZ',
    key: 'AZ',
    flag: 'az',
  },
  {
    text: 'Bahamas',
    value: 'BS',
    key: 'BS',
    flag: 'bs',
  },
  {
    text: 'Bahrain',
    value: 'BH',
    key: 'BH',
    flag: 'bh',
  },
  {
    text: 'Bangladesh',
    value: 'BD',
    key: 'BD',
    flag: 'bd',
  },
  {
    text: 'Barbados',
    value: 'BB',
    key: 'BB',
    flag: 'bb',
  },
  {
    text: 'Belarus',
    value: 'BY',
    flag: 'by',
  },
  {
    text: 'Belgium',
    value: 'BE',
    key: 'BE',
    flag: 'be',
  },
  {
    text: 'Belize',
    value: 'BZ',
    key: 'BZ',
    flag: 'bz',
  },
  {
    text: 'Benin',
    value: 'BJ',
    key: 'BJ',
    flag: 'bj',
  },
  {
    text: 'Bermuda',
    value: 'BM',
    key: 'BM',
    flag: 'bm',
  },
  {
    text: 'Bhutan',
    value: 'BT',
    key: 'BT',
    flag: 'bt',
  },
  {
    text: 'Bolivia',
    value: 'BO',
    key: 'BO',
    flag: 'bo',
  },
  {
    text: 'Bosnia and Herzegovina',
    value: 'BA',
    key: 'BA',
    flag: 'ba',
  },
  {
    text: 'Botswana',
    value: 'BW',
    key: 'BW',
    flag: 'bw',
  },
  {
    text: 'Bouvet Island',
    value: 'BV',
    key: 'BV',
    flag: 'bv',
  },
  {
    text: 'Brazil',
    value: 'BR',
    key: 'BR',
    flag: 'br',
  },
  {
    text: 'British Indian Ocean Territory',
    value: 'IO',
    key: 'IO',
    flag: 'io',
  },
  {
    text: 'Brunei Darussalam',
    value: 'BN',
    key: 'BN',
    flag: 'bn',
  },
  {
    text: 'Bulgaria',
    value: 'BG',
    key: 'BG',
    flag: 'bg',
  },
  {
    text: 'Burkina Faso',
    value: 'BF',
    key: 'BF',
    flag: 'bf',
  },
  {
    text: 'Burundi',
    value: 'BI',
    key: 'BI',
    flag: 'bi',
  },
  {
    text: 'Cambodia',
    value: 'KH',
    key: 'KH',
    flag: 'kh',
  },
  {
    text: 'Cameroon',
    value: 'CM',
    flag: 'cm',
  },
  {
    text: 'Canada',
    value: 'CA',
    key: 'CA',
    flag: 'ca',
  },
  {
    text: 'Cape Verde',
    value: 'CV',
    key: 'CV',
    flag: 'cv',
  },
  {
    text: 'Cayman Islands',
    value: 'KY',
    key: 'KY',
    flag: 'ky',
  },
  {
    text: 'Central African Republic',
    value: 'CF',
    key: 'CF',
    flag: 'cf',
  },
  {
    text: 'Chad',
    value: 'TD',
    key: 'TD',
    flag: 'td',
  },
  {
    text: 'Chile',
    value: 'CL',
    key: 'CL',
    flag: 'cl',
  },
  {
    text: 'China',
    value: 'CN',
    key: 'CN',
    flag: 'cn',
  },
  {
    text: 'Christmas Island',
    value: 'CX',
    key: 'CX',
    flag: 'cx',
  },
  {
    text: 'Cocos (Keeling) Islands',
    value: 'CC',
    key: 'CC',
    flag: 'cc',
  },
  {
    text: 'Colombia',
    value: 'CO',
    key: 'CO',
    flag: 'co',
  },
  {
    text: 'Comoros',
    value: 'KM',
    key: 'KM',
    flag: 'km',
  },
  {
    text: 'Congo',
    value: 'CG',
    key: 'CG',
    flag: 'cg',
  },
  {
    text: 'Congo, The Democratic Republic of the',
    value: 'CD',
    key: 'CD',
    flag: 'cd',
  },
  {
    text: 'Cook Islands',
    value: 'CK',
    key: 'CK',
    flag: 'ck',
  },
  {
    text: 'Costa Rica',
    value: 'CR',
    key: 'CR',
    flag: 'cr',
  },
  {
    text: 'Cote D"Ivoire',
    value: 'CI',
    key: 'CI',
    flag: 'ci',
  },
  {
    text: 'Croatia',
    value: 'HR',
    key: 'HR',
    flag: 'hr',
  },
  {
    text: 'Cuba',
    value: 'CU',
    key: 'CU',
    flag: 'cu',
  },
  {
    text: 'Cyprus',
    value: 'CY',
    key: 'CY',
    flag: 'cy',
  },
  {
    text: 'Czech Republic',
    value: 'CZ',
    key: 'CZ',
    flag: 'cz',
  },
  {
    text: 'Denmark',
    value: 'DK',
    key: 'DK',
    flag: 'dk',
  },
  {
    text: 'Djibouti',
    value: 'DJ',
    key: 'DJ',
    flag: 'dj',
  },
  {
    text: 'Dominica',
    value: 'DM',
    key: 'DM',
    flag: 'dm',
  },
  {
    text: 'Dominican Republic',
    value: 'DO',
    key: 'DO',
    flag: 'do',
  },
  {
    text: 'Ecuador',
    value: 'EC',
    key: 'EC',
    flag: 'ec',
  },
  {
    text: 'Egypt',
    value: 'EG',
    key: 'EG',
    flag: 'eg',
  },
  {
    text: 'El Salvador',
    value: 'SV',
    key: 'SV',
    flag: 'sv',
  },
  {
    text: 'Equatorial Guinea',
    value: 'GQ',
    key: 'GQ',
    flag: 'gq',
  },
  {
    text: 'Eritrea',
    value: 'ER',
    key: 'ER',
    flag: 'er',
  },
  {
    text: 'Estonia',
    value: 'EE',
    key: 'EE',
    flag: 'ee',
  },
  {
    text: 'Ethiopia',
    value: 'ET',
    key: 'ET',
    flag: 'et',
  },
  {
    text: 'Falkland Islands (Malvinas)',
    value: 'FK',
    key: 'FK',
    flag: 'fk',
  },
  {
    text: 'Faroe Islands',
    value: 'FO',
    key: 'FO',
    flag: 'fo',
  },
  {
    text: 'Fiji',
    value: 'FJ',
    key: 'FJ',
    flag: 'fj',
  },
  {
    text: 'Finland',
    value: 'FI',
    key: 'FI',
    flag: 'fi',
  },
  {
    text: 'France',
    value: 'FR',
    key: 'FR',
    flag: 'fr',
  },
  {
    text: 'French Guiana',
    value: 'GF',
    key: 'GF',
    flag: 'gf',
  },
  {
    text: 'French Polynesia',
    value: 'PF',
    key: 'PF',
    flag: 'pf',
  },
  {
    text: 'French Southern Territories',
    value: 'TF',
    key: 'TF',
    flag: 'tf',
  },
  {
    text: 'Gabon',
    value: 'GA',
    key: 'GA',
    flag: 'ga',
  },
  {
    text: 'Gambia',
    value: 'GM',
    key: 'GM',
    flag: 'gm',
  },
  {
    text: 'Georgia',
    value: 'GE',
    key: 'GE',
    flag: 'ge',
  },
  {
    text: 'Germany',
    value: 'DE',
    key: 'DE',
    flag: 'de',
  },
  {
    text: 'Ghana',
    value: 'GH',
    key: 'GH',
    flag: 'gh',
  },
  {
    text: 'Gibraltar',
    value: 'GI',
    key: 'GI',
    flag: 'gi',
  },
  {
    text: 'Greece',
    value: 'GR',
    key: 'GR',
    flag: 'gr',
  },
  {
    text: 'Greenland',
    value: 'GL',
    key: 'GL',
    flag: 'gl',
  },
  {
    text: 'Grenada',
    value: 'GD',
    key: 'GD',
    flag: 'gd',
  },
  {
    text: 'Guadeloupe',
    value: 'GP',
    key: 'GP',
    flag: 'gp',
  },
  {
    text: 'Guam',
    value: 'GU',
    key: 'GU',
    flag: 'gu',
  },
  {
    text: 'Guatemala',
    value: 'GT',
    flag: 'gt',
  },
  {
    text: 'Guinea',
    value: 'GN',
    key: 'GN',
    flag: 'gn',
  },
  {
    text: 'Guinea-Bissau',
    value: 'GW',
    key: 'GW',
    flag: 'gw',
  },
  {
    text: 'Guyana',
    value: 'GY',
    key: 'GY',
    flag: 'gy',
  },
  {
    text: 'Haiti',
    value: 'HT',
    key: 'HT',
    flag: 'ht',
  },
  {
    text: 'Heard Island and Mcdonald Islands',
    value: 'HM',
    key: 'HM',
    flag: 'hm',
  },
  {
    text: 'Holy See (Vatican City State)',
    value: 'VA',
    key: 'VA',
    flag: 'va',
  },
  {
    text: 'Honduras',
    value: 'HN',
    key: 'HN',
    flag: 'hn',
  },
  {
    text: 'Hong Kong',
    value: 'HK',
    key: 'HK',
    flag: 'hk',
  },
  {
    text: 'Hungary',
    value: 'HU',
    key: 'HU',
    flag: 'hu',
  },
  {
    text: 'Iceland',
    value: 'IS',
    key: 'IS',
    flag: 'is',
  },
  {
    text: 'India',
    value: 'IN',
    key: 'IN',
    flag: 'in',
  },
  {
    text: 'Indonesia',
    value: 'ID',
    key: 'ID',
    flag: 'id',
  },
  {
    text: 'Iran, Islamic Republic Of',
    value: 'IR',
    key: 'IR',
    flag: 'ir',
  },
  {
    text: 'Iraq',
    value: 'IQ',
    key: 'IQ',
    flag: 'iq',
  },
  {
    text: 'Israel',
    value: 'IL',
    key: 'IL',
    flag: 'il',
  },
  {
    text: 'Italy',
    value: 'IT',
    key: 'IT',
    flag: 'it',
  },
  {
    text: 'Jamaica',
    value: 'JM',
    key: 'JM',
    flag: 'jm',
  },
  {
    text: 'Japan',
    value: 'JP',
    key: 'JP',
    flag: 'jp',
  },
  {
    text: 'Jordan',
    value: 'JO',
    key: 'JO',
    flag: 'jo',
  },
  {
    text: 'Kazakhstan',
    value: 'KZ',
    key: 'KZ',
    flag: 'kz',
  },
  {
    text: 'Kenya',
    value: 'KE',
    key: 'KE',
    flag: 'ke',
  },
  {
    text: 'Kiribati',
    value: 'KI',
    key: 'KI',
    flag: 'ki',
  },
  {
    text: 'Korea, Democratic People"S Republic of',
    value: 'KP',
    key: 'KP',
    flag: 'kp',
  },
  {
    text: 'Korea, Republic of',
    value: 'KR',
    key: 'KR',
    flag: 'kr',
  },
  {
    text: 'Kuwait',
    value: 'KW',
    key: 'KW',
    flag: 'kw',
  },
  {
    text: 'Kyrgyzstan',
    value: 'KG',
    key: 'KG',
    flag: 'kg',
  },
  {
    text: 'Lao People"S Democratic Republic',
    value: 'LA',
    key: 'LA',
    flag: 'la',
  },
  {
    text: 'Latvia',
    value: 'LV',
    key: 'LV',
    flag: 'lv',
  },
  {
    text: 'Lebanon',
    value: 'LB',
    key: 'LB',
    flag: 'lb',
  },
  {
    text: 'Lesotho',
    value: 'LS',
    key: 'LS',
    flag: 'ls',
  },
  {
    text: 'Liberia',
    value: 'LR',
    key: 'LR',
    flag: 'lr',
  },
  {
    text: 'Libyan Arab Jamahiriya',
    value: 'LY',
    key: 'LY',
    flag: 'ly',
  },
  {
    text: 'Liechtenstein',
    value: 'LI',
    key: 'LI',
    flag: 'li',
  },
  {
    text: 'Lithuania',
    value: 'LT',
    key: 'LT',
    flag: 'lt',
  },
  {
    text: 'Luxembourg',
    value: 'LU',
    key: 'LU',
    flag: 'lu',
  },
  {
    text: 'Macao',
    value: 'MO',
    key: 'MO',
    flag: 'mo',
  },
  {
    text: 'Macedonia, The Former Yugoslav Republic of',
    value: 'MK',
    key: 'MK',
    flag: 'mk',
  },
  {
    text: 'Madagascar',
    value: 'MG',
    key: 'MG',
    flag: 'mg',
  },
  {
    text: 'Malawi',
    value: 'MW',
    key: 'MW',
    flag: 'mw',
  },
  {
    text: 'Malaysia',
    value: 'MY',
    key: 'MY',
    flag: 'my',
  },
  {
    text: 'Maldives',
    value: 'MV',
    key: 'MV',
    flag: 'mv',
  },
  {
    text: 'Mali',
    value: 'ML',
    key: 'ML',
    flag: 'ml',
  },
  {
    text: 'Malta',
    value: 'MT',
    key: 'MT',
    flag: 'mt',
  },
  {
    text: 'Marshall Islands',
    value: 'MH',
    key: 'MH',
    flag: 'mh',
  },
  {
    text: 'Martinique',
    value: 'MQ',
    key: 'MQ',
    flag: 'mq',
  },
  {
    text: 'Mauritania',
    value: 'MR',
    key: 'MR',
    flag: 'mr',
  },
  {
    text: 'Mauritius',
    value: 'MU',
    key: 'MU',
    flag: 'mu',
  },
  {
    text: 'Mayotte',
    value: 'YT',
    key: 'YT',
    flag: 'yt',
  },
  {
    text: 'Mexico',
    value: 'MX',
    key: 'MX',
    flag: 'mx',
  },
  {
    text: 'Micronesia, Federated States of',
    value: 'FM',
    key: 'FM',
    flag: 'fm',
  },
  {
    text: 'Moldova, Republic of',
    value: 'MD',
    key: 'MD',
    flag: 'md',
  },
  {
    text: 'Monaco',
    value: 'MC',
    key: 'MC',
    flag: 'mc',
  },
  {
    text: 'Mongolia',
    value: 'MN',
    key: 'MN',
    flag: 'mn',
  },
  {
    text: 'Montserrat',
    value: 'MS',
    key: 'MS',
    flag: 'ms',
  },
  {
    text: 'Morocco',
    value: 'MA',
    key: 'MA',
    flag: 'ma',
  },
  {
    text: 'Mozambique',
    value: 'MZ',
    key: 'MZ',
    flag: 'mz',
  },
  {
    text: 'Myanmar',
    value: 'MM',
    key: 'MM',
    flag: 'mm',
  },
  {
    text: 'Namibia',
    value: 'NA',
    key: 'NA',
    flag: 'na',
  },
  {
    text: 'Nauru',
    value: 'NR',
    key: 'NR',
    flag: 'nr',
  },
  {
    text: 'Nepal',
    value: 'NP',
    key: 'NP',
    flag: 'np',
  },
  {
    text: 'Netherlands',
    value: 'NL',
    key: 'NL',
    flag: 'nl',
  },
  {
    text: 'Netherlands Antilles',
    value: 'AN',
    key: 'AN',
    flag: 'an',
  },
  {
    text: 'New Caledonia',
    value: 'NC',
    key: 'NC',
    flag: 'nc',
  },
  {
    text: 'New Zealand',
    value: 'NZ',
    key: 'NZ',
    flag: 'nz',
  },
  {
    text: 'Nicaragua',
    value: 'NI',
    key: 'NI',
    flag: 'ni',
  },
  {
    text: 'Niger',
    value: 'NE',
    key: 'NE',
    flag: 'ne',
  },
  {
    text: 'Nigeria',
    value: 'NG',
    key: 'NG',
    flag: 'ng',
  },
  {
    text: 'Niue',
    value: 'NU',
    key: 'NU',
    flag: 'nu',
  },
  {
    text: 'Norfolk Island',
    value: 'NF',
    key: 'NF',
    flag: 'nf',
  },
  {
    text: 'Northern Mariana Islands',
    value: 'MP',
    key: 'MP',
    flag: 'mp',
  },
  {
    text: 'Norway',
    value: 'NO',
    key: 'NO',
    flag: 'no',
  },
  {
    text: 'Oman',
    value: 'OM',
    key: 'OM',
    flag: 'om',
  },
  {
    text: 'Pakistan',
    value: 'PK',
    key: 'PK',
    flag: 'pk',
  },
  {
    text: 'Palau',
    value: 'PW',
    key: 'PW',
    flag: 'pw',
  },
  {
    text: 'Palestinian Territory, Occupied',
    value: 'PS',
    key: 'PS',
    flag: 'ps',
  },
  {
    text: 'Panama',
    value: 'PA',
    key: 'PA',
    flag: 'pa',
  },
  {
    text: 'Papua New Guinea',
    value: 'PG',
    key: 'PG',
    flag: 'pg',
  },
  {
    text: 'Paraguay',
    value: 'PY',
    key: 'PY',
    flag: 'py',
  },
  {
    text: 'Peru',
    value: 'PE',
    key: 'PE',
    flag: 'pe',
  },
  {
    text: 'Philippines',
    value: 'PH',
    key: 'PH',
    flag: 'ph',
  },
  {
    text: 'Pitcairn',
    value: 'PN',
    key: 'PN',
    flag: 'pn',
  },
  {
    text: 'Poland',
    value: 'PL',
    key: 'PL',
    flag: 'pl',
  },
  {
    text: 'Portugal',
    value: 'PT',
    key: 'PT',
    flag: 'pt',
  },
  {
    text: 'Puerto Rico',
    value: 'PR',
    key: 'PR',
    flag: 'pr',
  },
  {
    text: 'Qatar',
    value: 'QA',
    key: 'QA',
    flag: 'qa',
  },
  {
    text: 'Reunion',
    value: 'RE',
    key: 'RE',
    flag: 're',
  },
  {
    text: 'Romania',
    value: 'RO',
    key: 'RO',
    flag: 'ro',
  },
  {
    text: 'Russian Federation',
    value: 'RU',
    key: 'RU',
    flag: 'ru',
  },
  {
    text: 'RWANDA',
    value: 'RW',
    key: 'RW',
    flag: 'rw',
  },
  {
    text: 'Saint Helena',
    value: 'SH',
    key: 'SH',
    flag: 'sh',
  },
  {
    text: 'Saint Kitts and Nevis',
    value: 'KN',
    key: 'KN',
    flag: 'kn',
  },
  {
    text: 'Saint Lucia',
    value: 'LC',
    key: 'LC',
    flag: 'lc',
  },
  {
    text: 'Saint Pierre and Miquelon',
    value: 'PM',
    key: 'PM',
    flag: 'pm',
  },
  {
    text: 'Saint Vincent and the Grenadines',
    value: 'VC',
    key: 'VC',
    flag: 'vc',
  },
  {
    text: 'Samoa',
    value: 'WS',
    key: 'WS',
    flag: 'ws',
  },
  {
    text: 'San Marino',
    value: 'SM',
    key: 'SM',
    flag: 'sm',
  },
  {
    text: 'Sao Tome and Principe',
    value: 'ST',
    key: 'ST',
    flag: 'st',
  },
  {
    text: 'Saudi Arabia',
    value: 'SA',
    key: 'SA',
    flag: 'sa',
  },
  {
    text: 'Senegal',
    value: 'SN',
    key: 'SN',
    flag: 'sn',
  },
  {
    text: 'Serbia',
    value: 'RS',
    key: 'RS',
    flag: 'rs',
  },
  {
    text: 'Montenegro',
    value: 'ME',
    key: 'ME',
    flag: 'me',
  },
  {
    text: 'Seychelles',
    value: 'SC',
    key: 'SC',
    flag: 'sc',
  },
  {
    text: 'Sierra Leone',
    value: 'SL',
    key: 'SL',
    flag: 'sl',
  },
  {
    text: 'Singapore',
    value: 'SG',
    key: 'SG',
    flag: 'sg',
  },
  {
    text: 'Slovakia',
    value: 'SK',
    key: 'SK',
    flag: 'sk',
  },
  {
    text: 'Slovenia',
    value: 'SI',
    key: 'SI',
    flag: 'si',
  },
  {
    text: 'Solomon Islands',
    value: 'SB',
    key: 'SB',
    flag: 'sb',
  },
  {
    text: 'Somalia',
    value: 'SO',
    key: 'SO',
    flag: 'so',
  },
  {
    text: 'South Africa',
    value: 'ZA',
    key: 'ZA',
    flag: 'za',
  },
  {
    text: 'South Georgia and the South Sandwich Islands',
    value: 'GS',
    key: 'GS',
    flag: 'gs',
  },
  {
    text: 'Spain',
    value: 'ES',
    key: 'ES',
    flag: 'es',
  },
  {
    text: 'Sri Lanka',
    value: 'LK',
    key: 'LK',
    flag: 'lk',
  },
  {
    text: 'Sudan',
    value: 'SD',
    key: 'SD',
    flag: 'sd',
  },
  {
    text: 'Suritext',
    value: 'SR',
    key: 'SR',
    flag: 'sr',
  },
  {
    text: 'Svalbard and Jan Mayen',
    value: 'SJ',
    key: 'SJ',
    flag: 'sj',
  },
  {
    text: 'Swaziland',
    value: 'SZ',
    key: 'SZ',
    flag: 'sz',
  },
  {
    text: 'Sweden',
    value: 'SE',
    key: 'SE',
    flag: 'se',
  },
  {
    text: 'Switzerland',
    value: 'CH',
    key: 'CH',
    flag: 'ch',
  },
  {
    text: 'Syrian Arab Republic',
    value: 'SY',
    key: 'SY',
    flag: 'sy',
  },
  {
    text: 'Taiwan, Province of China',
    value: 'TW',
    key: 'TW',
    flag: 'tw',
  },
  {
    text: 'Tajikistan',
    value: 'TJ',
    key: 'TJ',
    flag: 'tj',
  },
  {
    text: 'Tanzania, United Republic of',
    value: 'TZ',
    key: 'TZ',
    flag: 'tz',
  },
  {
    text: 'Thailand',
    value: 'TH',
    key: 'TH',
    flag: 'th',
  },
  {
    text: 'Timor-Leste',
    value: 'TL',
    key: 'TL',
    flag: 'tl',
  },
  {
    text: 'Togo',
    value: 'TG',
    key: 'TG',
    flag: 'tg',
  },
  {
    text: 'Tokelau',
    value: 'TK',
    key: 'TK',
    flag: 'tk',
  },
  {
    text: 'Tonga',
    value: 'TO',
    key: 'TO',
    flag: 'to',
  },
  {
    text: 'Trinidad and Tobago',
    value: 'TT',
    key: 'TT',
    flag: 'tt',
  },
  {
    text: 'Tunisia',
    value: 'TN',
    key: 'TN',
    flag: 'tn',
  },
  {
    text: 'Turkey',
    value: 'TR',
    key: 'TR',
    flag: 'gw',
  },
  {
    text: 'Turkmenistan',
    value: 'TM',
    key: 'TM',
    flag: 'tm',
  },
  {
    text: 'Turks and Caicos Islands',
    value: 'TC',
    key: 'TC',
    flag: 'tc',
  },
  {
    text: 'Tuvalu',
    value: 'TV',
    key: 'TV',
    flag: 'tv',
  },
  {
    text: 'Uganda',
    value: 'UG',
    key: 'UG',
    flag: 'ug',
  },
  {
    text: 'Ukraine',
    value: 'UA',
    key: 'UA',
    flag: 'ua',
  },
  {
    text: 'United Arab Emirates',
    value: 'AE',
    key: 'AE',
    flag: 'ae',
  },
  {
    text: 'United States Minor Outlying Islands',
    value: 'UM',
    key: 'UM',
    flag: 'um',
  },
  {
    text: 'Uruguay',
    value: 'UY',
    key: 'UY',
    flag: 'uy',
  },
  {
    text: 'Uzbekistan',
    value: 'UZ',
    key: 'UZ',
    flag: 'uz',
  },
  {
    text: 'Vanuatu',
    value: 'VU',
    key: 'VU',
    flag: 'vu',
  },
  {
    text: 'Venezuela',
    value: 'VE',
    key: 'VE',
    flag: 've',
  },
  {
    text: 'Viet Nam',
    value: 'VN',
    key: 'VN',
    flag: 'vn',
  },
  {
    text: 'Virgin Islands, British',
    value: 'VG',
    key: 'VG',
    flag: 'vg',
  },
  {
    text: 'Virgin Islands, U.S.',
    value: 'VI',
    key: 'VI',
    flag: 'vi',
  },
  {
    text: 'Wallis and Futuna',
    value: 'WF',
    key: 'WF',
    flag: 'wf',
  },
  {
    text: 'Western Sahara',
    value: 'EH',
    key: 'EH',
    flag: 'eh',
  },
  {
    text: 'Yemen',
    value: 'YE',
    key: 'YE',
    flag: 'ye',
  },
  {
    text: 'Zambia',
    value: 'ZM',
    key: 'ZM',
    flag: 'zm',
  },
  {
    text: 'Zimbabwe',
    value: 'ZW',
    key: 'ZW',
    flag: 'zw',
  },
];

export default countries;



/** WEBPACK FOOTER **
 ** ./src/utils/helpers/countries.js
 **/